import { useEffect, useState } from "react";
import axiosClient from "../../../../utils/api/axiosClient";
import { getToken } from "../../../../utils/functions";
import FormModel from "./models/FormModel";

export interface ILanguage {
  id: number;
  name: string;
  code: string;
  rtl: boolean;
}

export const initialFormData = { id: 0, name: "", code: "", rtl: false };

function Language() {
  const [languages, setLanguages] = useState<ILanguage[]>([]);
  const [initial, setInitial] = useState<ILanguage>(initialFormData);

  useEffect(() => {
    const headers = { Authorization: getToken() };
    axiosClient.get("v1/languages", { headers }).then((res) => {
      if (res.status === 200) setLanguages(res.data);
    });
  }, []);

  const handleDelete = (id: number) => {
    const headers = { Authorization: getToken() };
    axiosClient.delete("v1/languages/" + id, { headers }).then((res) => {
      if (res.status === 200) setLanguages(res.data);
    });
  };

  const handleEdit = (language: ILanguage) => {
    setInitial(language);
    setModalShow(true);
  };

  const handleCreate = () => {
    setInitial(initialFormData);
    setModalShow(true);
  };

  const [modalShow, setModalShow] = useState(false);

  return (
    <div className="app-content pt-3 p-md-3 p-lg-4">
      <div className="container-xl">
        <h1 className="app-page-title">Language</h1>
        <div className="row">
          <div className=" col-lg-12 ">
            <div className="card">
              <div className="card-header gutters-5">
                <h5 className="mb-md-0 h6">
                  All Language
                  <i
                    onClick={handleCreate}
                    className="fa fa-plus btn btn-sm pull-right"
                  ></i>
                </h5>
              </div>
              <div className="card-body">
                <table className="table aiz-table mb-0 footable footable-1 breakpoint-lg">
                  <thead>
                    <tr className="footable-header">
                      <th style={{ display: "table-cell" }}>#</th>
                      <th style={{ display: "table-cell" }}>Name</th>
                      <th style={{ display: "table-cell" }}>Code</th>
                      <th style={{ display: "table-cell" }}>RTL</th>
                      <th
                        className="text-right"
                        style={{ display: "table-cell", width: "20%" }}
                      >
                        Options
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {languages.length ? (
                      languages.map((language, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{language.name}</td>
                            <td>{language.code}</td>
                            <td>{language.rtl ? "TRUE" : "FALSE"}</td>
                            <td>
                              <i
                                className="fa fa-pencil btn btn-sm"
                                onClick={() => handleEdit(language)}
                              ></i>
                              <i
                                className="fa fa-trash btn btn-sm"
                                onClick={() => handleDelete(language.id)}
                              ></i>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="footable-empty text-center">
                        <td colSpan={3}>Nothing Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="aiz-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormModel
        {...{ setLanguages, initial, setInitial, modalShow, setModalShow }}
      />
    </div>
  );
}

export default Language;
